import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.23.2_react-dom@18.2.0_react@18.2.0_sass@1.69.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.23.2_react-dom@18.2.0_react@18.2.0_sass@1.69.5/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Headers/LinkBluKai.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RenewalReminder/RenewalReminder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/Home/Categories.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/containers/Home/HomeSlider.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/sass/modules/_home2.scss");
